import React, { Component } from "react";
import { MicroAssessmentTool } from "@ifthen/dematic";

class MicroAssessment extends Component {
  render() {
    return (
      <MicroAssessmentTool
        base_path="/etc.clientlibs/dematic/clientlibs/clientlib-react/resources/assets/"
        {...this.props}
      />
    );
  }
}

export default MicroAssessment;
